import React from "react";
import navLeft from "../images/icon/arrow_left.svg";
import navRight from "../images/icon/arrow_right.svg";

const Nav = ({ onNavigation, currentIndex }) => {
  const handleNextClick = (e) => {
    e.preventDefault();
    onNavigation(1);
  };

  const handlePreviousClick = (e) => {
    e.preventDefault();
    onNavigation(-1);
  };

  const identifier = `${currentIndex.flow}-${currentIndex.section + 1}`;

  return (
    <div className="app-options__nav">
      <button
        onClick={handleNextClick}
        data-identifier={identifier}
        type="button"
        className="next"
        aria-label="Navigate to Next Page">
        <img alt="icon with arrow pointing to the right" src={navRight} />
      </button>
      <button
        onClick={handlePreviousClick}
        data-identifier={identifier}
        type="button"
        className="previous"
        aria-label="Navigate to Previous Page">
        <img alt="icon with arrow pointing to the left" src={navLeft} />
      </button>
    </div>
  );
};

export default Nav;
